



















































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { BvEvent } from 'bootstrap-vue';
import { companiesCollection, auth } from '@/firebaseConfig.ts';
import { Company } from '@/types';

@Component
export default class Companies extends Vue {
  private newCompany: Company = {} as Company;

  private companies: Array<Company> = [];

  private modFieldVal: string = '';

  private isAddingCompany: Boolean = false;

  async mounted() {
    companiesCollection.onSnapshot(snapshot => {
      if (!snapshot.empty) {
        const data: Array<Company> = [];
        snapshot.forEach(doc => {
          const company = doc.data() as Company;
          data.push(company);
        });
        this.companies = data;
        console.log(data);
      }
    });
  }

  hideModal(modalId: string) {
    this.$bvModal.hide(modalId);
  }

  resetNewCompanyForm() {
    const companyFormat = {
      name: '',
      id: '',
      manager: '',
      mods: [],
      userCount: 0,
    } as Company;
    this.newCompany = companyFormat;
  }

  addModerator() {
    const mod = this.modFieldVal.trim();
    if (mod) {
      this.newCompany.mods.push(mod);
      this.modFieldVal = '';
    }
  }

  removeModerator(index: number) {
    if (this.newCompany.hasOwnProperty('mods')) {
      const { mods } = this.newCompany;
      mods.splice(index, 1);
      this.newCompany.mods = mods;
    }
  }

  async addCompany() {
    this.isAddingCompany = true;
    try {
      const companyId: string = this.newCompany.id;
      const company = this.newCompany;
      company.mods = company.mods.filter(mod => mod.trim().length > 0);
      const docId = await companiesCollection
        .doc(companyId)
        .set(company, { merge: true })
        .catch(err => console.log(err));
      this.$bvModal.hide('addCompanyModal');
    } catch (err) {
      console.log(err);
    } finally {
      this.isAddingCompany = false;
    }
  }

  async deleteCompany(companyId: string) {
    try {
      const confirmation = await this.$bvModal.msgBoxConfirm(
        'This will permanently delete this company.',
        {
          title: 'Please Confirm',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Delete',
          cancelTitle: 'Cancel',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        },
      );
      if (confirmation) {
        const docId = await companiesCollection.doc(companyId).delete();
      }
    } catch (err) {
      console.log(err);
    }
  }
}
